import React, { useContext } from 'react';
import { Typography, Icon, makeStyles, Theme } from '@material-ui/core';
import { Trans } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { ritzDataContext, selectProjectById } from '@moderepo/mode-data-state-ritz';
import { useRitzTranslation } from '../../utils/customHooks';



const useStyle = makeStyles((theme: Theme) => {
    return {
        root: {
            textAlign: 'center',
            padding  : theme.spacing(4),
            position : 'absolute',
            width    : '100%',
            height   : '100%',
        },

        icon: {
            fontSize    : '100px',
            marginBottom: theme.spacing(2),
        },

        title: {
            paddingBottom: theme.spacing(2),
        },

        subtitle: {

        },
    };
}, { name: 'NotFoundPage' });



export const NotFound: React.FC = () => {
    const params = useParams();
    const projectId = params.projectId ? Number(params.projectId) : undefined;
    const { state:dataState } = useContext(ritzDataContext);
    const project = projectId ? selectProjectById(dataState, projectId) : undefined;
    const { trans } = useRitzTranslation(project);
    const classes = useStyle();

    return (
        <div className={classes.root}>
            <Icon className={classes.icon}>sentiment_very_dissatisfied</Icon>
            <Typography variant="h3" className={classes.title}>{trans('page.not_found.title')}</Typography>
            <Typography variant="h6">
                {/*
                    This translation is a little tricky because it contains links. For this case, we must use the
                    <Trans /> component. "i18nKey" is the key/placeholder in the translation json file which will
                    be translated to this "We seem to have lost you in the clouds. Come back to ours <0>here</0>."
                    <0>here</0> tells the translation system to replace it with the FIRST child in the <Trans/> below,
                    which will be <Link to="/"></Link>. Use <1>...</1> for seconds child, <2>...</2> for third child and so on.
                    See https://react.i18next.com/latest/trans-component for more details on how to use <Trans />
                */}
                <Trans i18nKey="page.not_found.subtitle" className={classes.subtitle}>
                    <Link to="/" />
                </Trans>
            </Typography>
        </div>
    );
};
